export default __webpack_public_path__ + "static/media/register2.d5108005.jpg";